import { render } from "./PublicUserSettingsView.vue?vue&type=template&id=af8f8836&scoped=true"
import script from "./PublicUserSettingsView.vue?vue&type=script&lang=js"
export * from "./PublicUserSettingsView.vue?vue&type=script&lang=js"

import "./PublicUserSettingsView.vue?vue&type=style&index=0&id=af8f8836&lang=less&scoped=true"
import "./PublicUserSettingsView.vue?vue&type=style&index=1&id=af8f8836&lang=less"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8f8836"]])

export default __exports__